import { render, staticRenderFns } from "./SplitCell.vue?vue&type=template&id=1c245141"
import script from "./SplitCell.vue?vue&type=script&lang=js"
export * from "./SplitCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports